<template>
  <v-container v-if="user">
    <user-data-form :user="user"></user-data-form>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import UserDataForm from "./UserDataForm";

export default {
  components: { UserDataForm },
  data: () => ({
    user: null,
  }),
  computed: {
    ...mapGetters(["currentUser"]),
  },
  mounted() {
    this.user = JSON.parse(JSON.stringify(this.currentUser));
  },
  watch: {
    currentGroups() {
      this.user = JSON.parse(JSON.stringify(this.currentUser));
    },
  },
};
</script>
